import React from 'react';
import { string, func } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { getPageName } from '@blueberry/redux/home';

import styles from './SubjectHandler.scss';

import CloudRight from './images/img-bg-1.svg';
import CloudLeft from './images/img-bg-2.svg';

import rightTransition from './rightTransition.scss';
import leftTransition from './leftTransition.scss';

const mapStateToProps = state => ({
  name: getPageName(state),
});

function SubjectHandler({ name, t }) {
  const { bg1, bg2 } = t(`subject:subject.subjects.${name}`, {
    returnObjects: true,
    defaultValue: {},
  });

  return (
    <div>
      <ReactCSSTransitionGroup
        transitionName={rightTransition}
        transitionAppearTimeout={500}
        transitionAppear
        transitionEnterTimeout={500}
        transitionLeaveTimeout={300}
      >
        <img src={CloudLeft} className={styles.cloudLeft} key={bg1} />
      </ReactCSSTransitionGroup>
      <ReactCSSTransitionGroup
        transitionName={leftTransition}
        transitionAppearTimeout={500}
        transitionAppear
        transitionEnterTimeout={500}
        transitionLeaveTimeout={300}
      >
        <img src={CloudRight} className={styles.cloudRight} key={bg2} />
      </ReactCSSTransitionGroup>
    </div>
  );
}

SubjectHandler.propTypes = {
  name: string.isRequired,
  t: func.isRequired,
};

export default compose(
  translate(['subject']),
  connect(mapStateToProps)
)(SubjectHandler);



// WEBPACK FOOTER //
// ./app/containers/SubjectHandler/SubjectHandler.jsx